// PartBPage7.jsx - Part B Page 7 (Overview Summary) for HPC Report
import React from 'react';

const PartBPage7 = ({ data }) => {
  // Calculate totals from previous pages
  const calcTotals = () => {
    const teacherStage1 = {
      awareness: data?.page_3?.stage1?.awareness?.length || 0,
      sensitivity: data?.page_3?.stage1?.sensitivity?.length || 0,
      creativity: data?.page_3?.stage1?.creativity?.length || 0
    };
    const teacherStage2 = {
      awareness: data?.page_4?.stage2?.awareness?.length || 0,
      sensitivity: data?.page_4?.stage2?.sensitivity?.length || 0,
      creativity: data?.page_4?.stage2?.creativity?.length || 0
    };
    const teacherStage3Rubric = data?.page_6?.rubric || {};
    const teacherStage3 = {
      awareness: teacherStage3Rubric.awareness_level === 'beginner' ? 5 : teacherStage3Rubric.awareness_level === 'proficient' ? 10 : teacherStage3Rubric.awareness_level === 'advanced' ? 15 : 0,
      sensitivity: teacherStage3Rubric.sensitivity_level === 'beginner' ? 5 : teacherStage3Rubric.sensitivity_level === 'proficient' ? 10 : teacherStage3Rubric.sensitivity_level === 'advanced' ? 15 : 0,
      creativity: teacherStage3Rubric.creativity_level === 'beginner' ? 5 : teacherStage3Rubric.creativity_level === 'proficient' ? 10 : teacherStage3Rubric.creativity_level === 'advanced' ? 15 : 0
    };

    const learnerStage1 = {
      awareness: data?.page_2?.awareness ? Object.values(data.page_2.awareness).filter(Boolean).length : 0,
      sensitivity: data?.page_2?.sensitivity ? Object.values(data.page_2.sensitivity).filter(Boolean).length : 0,
      creativity: data?.page_2?.creativity ? Object.values(data.page_2.creativity).filter(Boolean).length : 0
    };
    const learnerStage3 = {
      awareness: data?.page_5?.learner_reflection?.awareness?.length || 0,
      sensitivity: data?.page_5?.learner_reflection?.sensitivity?.length || 0,
      creativity: data?.page_5?.learner_reflection?.creativity?.length || 0
    };

    const peerStage3 = {
      awareness: data?.page_5?.peer_feedback?.awareness?.length || 0,
      sensitivity: data?.page_5?.peer_feedback?.sensitivity?.length || 0,
      creativity: data?.page_5?.peer_feedback?.creativity?.length || 0
    };

    return {
      teacher: {
        stage1: teacherStage1, stage2: teacherStage2, stage3: teacherStage3,
        total: {
          awareness: teacherStage1.awareness + teacherStage2.awareness + teacherStage3.awareness,
          sensitivity: teacherStage1.sensitivity + teacherStage2.sensitivity + teacherStage3.sensitivity,
          creativity: teacherStage1.creativity + teacherStage2.creativity + teacherStage3.creativity
        }
      },
      learner: {
        stage1: learnerStage1, stage3: learnerStage3,
        total: {
          awareness: learnerStage1.awareness + learnerStage3.awareness,
          sensitivity: learnerStage1.sensitivity + learnerStage3.sensitivity,
          creativity: learnerStage1.creativity + learnerStage3.creativity
        }
      },
      peer: { stage3: peerStage3 }
    };
  };

  const totals = calcTotals();

  // Backend now correctly merges teacher and student data for page_7
  const teacherPerf = data?.page_7?.teacher_assessment || {};
  const learnerPerf = data?.page_7?.learner_reflection || {};
  const peerPerf = data?.page_7?.peer_feedback || {};

  const renderPerformanceCheckboxes = (ability, selectedLevel) => {
    const levels = [
      { key: 'beginner', label: 'Beginner', range: '(5-13)' },
      { key: 'proficient', label: 'Proficient', range: '(12-18)' },
      { key: 'advanced', label: 'Advanced', range: '(19-20)' }
    ];

    return (
      <div style={{ display: 'flex', gap: '8px', marginBottom: '6px', alignItems: 'center' }}>
        <div style={{
          backgroundColor: '#3F51B5',
          color: 'white',
          padding: '6px 16px',
          fontWeight: 'bold',
          fontSize: '10px',
          minWidth: '90px',
          textAlign: 'center'
        }}>
          {ability}
        </div>
        {levels.map(level => (
          <div key={level.key} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px' }}>
            <div style={{
              backgroundColor: level.key === selectedLevel ? '#FFD700' : '#F5F5F5',
              border: '2px solid #333',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '9px',
              fontWeight: 'bold',
              textAlign: 'center',
              minWidth: '60px'
            }}>
              {level.label}<br />{level.range}
            </div>
            <div style={{
              width: '16px',
              height: '16px',
              border: '2px solid #333',
              backgroundColor: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px'
            }}>
              {level.key === selectedLevel && '✓'}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderTable = (title, stageData) => (
    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '6px' }}>
      <thead>
        <tr style={{ backgroundColor: '#FFD700' }}>
          <th style={{ border: '2px solid #333', padding: '4px', fontSize: '10px', fontWeight: 'bold', textAlign: 'center' }}>{title}</th>
          <th style={{ border: '2px solid #333', padding: '4px', fontSize: '10px', fontWeight: 'bold' }}>Awareness</th>
          <th style={{ border: '2px solid #333', padding: '4px', fontSize: '10px', fontWeight: 'bold' }}>Sensitivity</th>
          <th style={{ border: '2px solid #333', padding: '4px', fontSize: '10px', fontWeight: 'bold' }}>Creativity</th>
        </tr>
      </thead>
      <tbody>
        {stageData.map((row, idx) => (
          <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#FFF9E6' : 'white' }}>
            <td style={{ border: '2px solid #333', padding: '4px', fontSize: '10px', fontWeight: row.label === 'Total' ? 'bold' : 'normal', textAlign: 'center' }}>{row.label}</td>
            <td style={{ border: '2px solid #333', padding: '4px', fontSize: '10px', textAlign: 'center' }}>{row.data.awareness}</td>
            <td style={{ border: '2px solid #333', padding: '4px', fontSize: '10px', textAlign: 'center' }}>{row.data.sensitivity}</td>
            <td style={{ border: '2px solid #333', padding: '4px', fontSize: '10px', textAlign: 'center' }}>{row.data.creativity}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      <div style={{ position: 'absolute', top: 0, right: 0, width: 0, height: 0, borderStyle: 'solid', borderWidth: '0 80px 80px 0', borderColor: 'transparent #F4824C transparent transparent' }} />

      {/* Header */}
      <div style={{ backgroundColor: '#F4824C', color: 'white', fontSize: '14px', fontWeight: 'bold', padding: '10px', textAlign: 'center', marginBottom: '6px' }}>
        Overview
      </div>
      <div style={{ backgroundColor: '#F4824C', color: 'white', fontSize: '11px', padding: '6px 10px', textAlign: 'center', marginBottom: '16px' }}>
        Tabulate all the feedback for the group project on this page.
      </div>

      {/* Teacher Assessment */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{ backgroundColor: '#F4824C', color: 'white', padding: '6px 10px', fontWeight: 'bold', fontSize: '11px', marginBottom: '6px' }}>
          Teacher Assessment
        </div>
        <div style={{ fontSize: '9px', marginBottom: '4px', lineHeight: '1.4' }}>
          <strong>1.</strong> For <strong>Stages 1</strong> and <strong>2</strong>, write the <strong>total</strong> number of statements you ticked.
          &nbsp;&nbsp;&nbsp;<strong>3.</strong> Tick the <strong>final performance level</strong> based on the final score.
        </div>
        <div style={{ fontSize: '9px', marginBottom: '6px', lineHeight: '1.4' }}>
          For <strong>Stage 3</strong>, write the numeric value that corresponds to the <strong>achievement level</strong> (beginner, proficient, advanced) for <strong>each ability</strong> (awareness, sensitivity, creativity) you chose for the final product.
        </div>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <div style={{ flex: 1 }}>
            {renderTable('Teacher', [
              { label: 'Stage 1', data: totals.teacher.stage1 },
              { label: 'Stage 2', data: totals.teacher.stage2 },
              { label: 'Stage 3', data: totals.teacher.stage3 },
              { label: 'Total', data: totals.teacher.total }
            ])}
            <div style={{ fontSize: '9px', marginTop: '4px' }}><strong>2.</strong> Add the total here. ↗</div>
          </div>
          <div style={{ flex: 0.8 }}>
            {renderPerformanceCheckboxes('Awareness', teacherPerf.awareness_performance_level)}
            {renderPerformanceCheckboxes('Sensitivity', teacherPerf.sensitivity_performance_level)}
            {renderPerformanceCheckboxes('Creativity', teacherPerf.creativity_performance_level)}
          </div>
        </div>
      </div>

      {/* Learner Reflection */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{ backgroundColor: '#4A90A4', color: 'white', padding: '6px 10px', fontWeight: 'bold', fontSize: '11px', marginBottom: '6px' }}>
          Learner Reflection
        </div>
        <div style={{ fontSize: '9px', marginBottom: '6px', lineHeight: '1.4' }}>
          <strong>1.</strong> For <strong>Stages 1</strong> and <strong>3</strong>, write the <strong>total</strong> number of statements the learner has ticked (✓).
          &nbsp;&nbsp;&nbsp;<strong>3.</strong> Tick the <strong>final performance level</strong> based on the final score.
        </div>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <div style={{ flex: 1 }}>
            {renderTable('Learner', [
              { label: 'Stage 1', data: totals.learner.stage1 },
              { label: 'Stage 3', data: totals.learner.stage3 },
              { label: 'Total', data: totals.learner.total }
            ])}
            <div style={{ fontSize: '9px', marginTop: '4px' }}><strong>2.</strong> Add the total here. ↗</div>
          </div>
          <div style={{ flex: 0.8 }}>
            {renderPerformanceCheckboxes('Awareness', learnerPerf.awareness_performance_level)}
            {renderPerformanceCheckboxes('Sensitivity', learnerPerf.sensitivity_performance_level)}
            {renderPerformanceCheckboxes('Creativity', learnerPerf.creativity_performance_level)}
          </div>
        </div>
      </div>

      {/* Peer Feedback */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{ backgroundColor: '#DAA520', color: 'white', padding: '6px 10px', fontWeight: 'bold', fontSize: '11px', marginBottom: '6px' }}>
          Peer Feedback
        </div>
        <div style={{ fontSize: '9px', marginBottom: '6px', lineHeight: '1.4' }}>
          <strong>1.</strong> For <strong>Stage 3</strong>, write the <strong>total</strong> number of statements the peer has ticked (✓).
          &nbsp;&nbsp;&nbsp;<strong>2.</strong> Tick the <strong>final performance level</strong> based on the score.
        </div>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
          <div style={{ flex: 1 }}>
            {renderTable('Peer', [
              { label: 'Stage 3', data: totals.peer.stage3 }
            ])}
          </div>
          <div style={{ flex: 0.8 }}>
            {renderPerformanceCheckboxes('Awareness', peerPerf.awareness_performance_level)}
            {renderPerformanceCheckboxes('Sensitivity', peerPerf.sensitivity_performance_level)}
            {renderPerformanceCheckboxes('Creativity', peerPerf.creativity_performance_level)}
          </div>
        </div>
      </div>

      {/* Page Number */}
      <div style={{ position: 'absolute', bottom: '15mm', left: '50%', transform: 'translateX(-50%)', fontSize: '10px', color: '#666', fontWeight: 'bold' }}>17</div>

      {/* Bottom Corners */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, width: 0, height: 0, borderStyle: 'solid', borderWidth: '60px 0 0 60px', borderColor: 'transparent transparent transparent #F4824C' }} />
      <div style={{ position: 'absolute', bottom: 0, right: 0, width: 0, height: 0, borderStyle: 'solid', borderWidth: '60px 60px 0 0', borderColor: 'transparent #F4824C transparent transparent', opacity: 0.3 }} />
    </div>
  );
};

export default PartBPage7;
